import { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

const CLOSED_STATUSES = ['WON', 'LOST', 'LOST_BUT_TRACK'];

export const SyncCloseDateOnStatus = () => {
  const { getValues, setValue } = useFormContext();
  const status = useWatch({ name: 'status' });
  const prevStatus = useRef(status);

  useEffect(() => {
    if (status === prevStatus.current) return;
    prevStatus.current = status;

    const isClosed = CLOSED_STATUSES.includes(status);
    const current = getValues('dateClosed');

    if (isClosed && !current) {
      setValue('dateClosed', new Date().toISOString().split('T')[0], {
        shouldDirty: true,
        shouldValidate: true
      });
    } else if (!isClosed && current) {
      setValue('dateClosed', null, { shouldDirty: true, shouldValidate: true });
    }
  }, [status, getValues, setValue]);

  return null;
};
